import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { ENV } from "../../config/config";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import validator from "validator";
import { useGetSettingsQuery, useEditSettingsMutation, useGetRoleQuery } from "../../redux/api";
var CryptoJS = require("crypto-js");

// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import SupportersForm from "./SupportersForm";
import SpendingChartForm from "./SpendingChartForm";

const SiteSettings = () => {
  const { data: settingsData, isLoading: isSettingsLoading } = useGetSettingsQuery();
  const [editSettingsMutation, { isLoading: isEditLoading }] = useEditSettingsMutation();
  const initialLinks = {
    twitter: "",
    youtube: "",
    linkedin: "",
    facebook: "",
    email: "",
    metaTitle: "",
    metaKeyword: "",
    metaDescription: "",
    homePageBannerImage: "",
    isDonut: false,
    donutMainHeading: "",
    donutSubHeading: "",
    defaultMainHeading: "",
    defaultSubHeading: "",
    featuredMainHeading: "",
    featuredSubHeading: "",
    supporterHeading: "",
    footerText: "",
    // blog: "",
    // skype: "",
  };
  const initialDonut = [{ label: "", data: "", color: "" }];

  const [links, setLinks] = useState(initialLinks);

  const [permissions, setPermissions] = useState({});
  const [msg, setMsg] = useState(initialLinks);


  const [donut, setDonut] = useState(initialDonut);

  const [supporter, setSupporter] = useState([]);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const error = useSelector((state) => state.error);


  const roleEncrypted = localStorage.getItem("role");
  const roleDecrypted = roleEncrypted
    ? CryptoJS.AES.decrypt(roleEncrypted, ENV.secretKey).toString(
        CryptoJS.enc.Utf8
      )
    : "";
  const { data: roleData, isLoading: isRoleLoading } = useGetRoleQuery(roleDecrypted, { skip: !roleEncrypted });
  useEffect(() => {
    if (roleData && roleData.role?.permissions) {
      if (typeof roleData.role.permissions === 'string') {
        setPermissions(JSON.parse(roleData.role.permissions));
      } else {
        setPermissions(roleData.role.permissions);
      }
    }
  }, [roleData]);

  useEffect(() => {
    if (settingsData) {
      const setting = settingsData.setting ?? settingsData;
      const donutData = settingsData.donut ?? [];
      const supporterData = settingsData.supporter ?? [];
      setLinks(setting);
      setDonut(donutData);
      setSupporter(supporterData);
    }
  }, [settingsData]);



  const save = () => {
    let check = true;

    const newMsg = { ...msg };

    if (validator.isEmpty(links.metaDescription)) {
      newMsg.metaDescription = "Meta Description is required";
      check = false;
    }
    if (validator.isEmpty(links.metaKeyword)) {
      newMsg.metaKeyword = "Meta Keywords are Required";
      check = false;
    }
    if (validator.isEmpty(links.metaTitle)) {
      newMsg.metaTitle = "Meta Title is Required";
      check = false;
    }

    if (!check) {
      setMsg(newMsg);
      return;
    }
    if (check) {
      const formData = new FormData();
      for (const key in links) {
        formData.append(key, links[key]);
      }

      (async () => {
        await editSettingsMutation(formData);
      })();
      setLinks(initialLinks);
    }
  };

  const onFileChange = (e) => {
    const file = e.target.files[0];
    const inputId = e.target.id; // Get the ID of the input field

    if (file) {
      const acceptedExtensions = [".jpg", ".jpeg", ".png"];
      const fileExtension = "." + file.name.split(".").pop().toLowerCase();

      if (!acceptedExtensions.includes(fileExtension)) {
        setMsg({
          ...msg,
          [inputId]:
            "Invalid file extension.\nValid file extensions are: jpg, jpeg, and png",
        });
        e.target.value = null; // Deselect the file
        setLinks({ ...links, [inputId]: null }); // Clear the image state
      } else {
        setLinks({ ...links, [inputId]: file }); // Update the image state with the selected file
      }
    }
  };

  if (isSettingsLoading || isEditLoading || isRoleLoading) {
    return <FullPageLoader />;
  }

  return (
    <>
      <Container fluid>
        <Row>
              <Col md="12">
                <Form
                  action=""
                  className="form-horizontal"
                  id="TypeValidation"
                  method=""
                >
                  <Card className="table-big-boy p-5">
                    {/* SOCIAL */}
                    <Card className="table-big-boy mb-5">
                      <Card.Header>
                        <div className="d-block d-md-flex align-items-center justify-content-between">
                          <Card.Title as="h4">Social Settings</Card.Title>
                        </div>
                      </Card.Header>

                      <Card.Body>
                        <Row>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                X / twitter
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.twitter}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    twitter: e.target.value,
                                  })
                                }
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                YouTube
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.youtube}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    youtube: e.target.value,
                                  })
                                }
                              ></Form.Control>
                            </Form.Group>
                          </Col>

                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Linked In
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.linkedin}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    linkedin: e.target.value,
                                  })
                                }
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Facebook
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.facebook}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    facebook: e.target.value,
                                  })
                                }
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Skype
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.skype}
                                onChange={(e) =>
                                  setLinks({ ...links, skype: e.target.value })
                                }
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Blog
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.blog}
                                onChange={(e) =>
                                  setLinks({ ...links, blog: e.target.value })
                                }
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Email
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.email}
                                onChange={(e) =>
                                  setLinks({ ...links, email: e.target.value })
                                }
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                    <hr className="centered-hr" />
                    <Card className="table-big-boy mb-5">
                      <Card.Body>
                        <Row>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Footer Text
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.footerText}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    footerText: e.target.value,
                                  })
                                }
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Supporter Heading
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.supporterHeading}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    supporterHeading: e.target.value,
                                  })
                                }
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                    <hr className="centered-hr" />
                    <Card className="table-big-boy mb-5">
                      <Card.Header>
                        <div className="d-block d-md-flex align-items-center justify-content-between">
                          <Card.Title as="h4">SEO Settings</Card.Title>
                        </div>
                      </Card.Header>

                      <Card.Body>
                        <Row>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Meta Title
                              </Form.Label>
                              <Form.Control
                                className={msg.metaTitle ? `on-error` : ``}
                                type="text"
                                value={links.metaTitle}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    metaTitle: e.target.value,
                                  })
                                }
                              ></Form.Control>
                              <span className={msg.metaTitle ? `` : `d-none`}>
                                <label className="pl-1 pt-0 text-danger">
                                  {msg.metaTitle}
                                </label>
                              </span>
                            </Form.Group>
                          </Col>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Meta Keyword
                              </Form.Label>
                              <Form.Control
                                className={msg.metaKeyword ? `on-error` : ``}
                                type="text"
                                value={links.metaKeyword}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    metaKeyword: e.target.value,
                                  })
                                }
                              ></Form.Control>
                              <span className={msg.metaKeyword ? `` : `d-none`}>
                                <label className="pl-1 pt-0 text-danger">
                                  {msg.metaKeyword}
                                </label>
                              </span>
                            </Form.Group>
                          </Col>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Meta Description
                              </Form.Label>
                              <Form.Control
                                className={
                                  msg.metaDescription ? `on-error` : ``
                                }
                                type="text"
                                value={links.metaDescription}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    metaDescription: e.target.value,
                                  })
                                }
                              ></Form.Control>
                              <span
                                className={msg.metaDescription ? `` : `d-none`}
                              >
                                <label className="pl-1 pt-0 text-danger">
                                  {msg.metaDescription}
                                </label>
                              </span>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                    <hr className="centered-hr" />

                    {/* <Card className="table-big-boy mb-5">
                      <Card.Header>
                        <div className="d-block d-md-flex align-items-center justify-content-between">
                          <Card.Title as="h4">Home Page Settings</Card.Title>
                        </div>
                      </Card.Header>
                      <Card.Body>
                        <Row>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Image
                              </Form.Label>
                              <Form.Control
                                placeholder="homePageBannerImage"
                                type="file"
                                varient="info"
                                accept=".jpg,.jpeg,.png"
                                onChange={(e) => onFileChange(e)}
                                id="homePageBannerImage"
                              />
                            </Form.Group>
                          </Col>

                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Text
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.homePageBannerText}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    homePageBannerText: e.target.value,
                                  })
                                }
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Buttton Url
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.homePageBannerBtnUrl}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    homePageBannerBtnUrl: e.target.value,
                                  })
                                }
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Video Button Url
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.homePageBannerVideoUrl}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    homePageBannerVideoUrl: e.target.value,
                                  })
                                }
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                    <hr className="centered-hr" /> */}

                    <Card className="table-big-boy mb-5">
                      <Card.Header>
                        <div className="d-block d-md-flex align-items-center justify-content-between">
                          <Card.Title as="h4">Banner Settings</Card.Title>
                        </div>
                      </Card.Header>
                      <Card.Body>
                        <Row>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Image
                              </Form.Label>
                              <Form.Control
                                placeholder="aboutBannerImage"
                                type="file"
                                varient="info"
                                accept=".jpg,.jpeg,.png"
                                onChange={(e) => onFileChange(e)}
                                id="aboutBannerImage"
                              />
                            </Form.Group>
                          </Col>

                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Text
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.aboutBannerText}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    aboutBannerText: e.target.value,
                                  })
                                }
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Orange Buttton Url
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.aboutBannerOrangeUrl}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    aboutBannerOrangeUrl: e.target.value,
                                  })
                                }
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                White Button Url
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.aboutBannerWhiteUrl}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    aboutBannerWhiteUrl: e.target.value,
                                  })
                                }
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                    <hr className="centered-hr" />

                    <Card className="table-big-boy mb-5">
                      <Card.Header>
                        <div className="d-block d-md-flex align-items-center justify-content-between">
                          <Card.Title as="h4">Donut Chart Settings</Card.Title>
                        </div>
                      </Card.Header>
                      <Card.Body>
                        <Row>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Show Donut Chart
                              </Form.Label>

                              <div className="d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  name="isDonut"
                                  onChange={(e) =>
                                    setLinks({
                                      ...links,
                                      isDonut: !links.isDonut,
                                    })
                                  }
                                  checked={links?.isDonut}
                                />
                                <span className="checkmark"></span>
                              </div>
                            </Form.Group>
                          </Col>
                          {links.isDonut && (
                            <>
                              <Col xl={4} md={6}>
                                <Form.Group>
                                  <Form.Label className="d-block mb-2">
                                    Main Heading
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={links.donutMainHeading}
                                    onChange={(e) =>
                                      setLinks({
                                        ...links,
                                        donutMainHeading: e.target.value,
                                      })
                                    }
                                  ></Form.Control>
                                </Form.Group>
                              </Col>
                              <Col xl={4} md={6}>
                                <Form.Group>
                                  <Form.Label className="d-block mb-2">
                                    Sub Heading
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={links.donutSubHeading}
                                    onChange={(e) =>
                                      setLinks({
                                        ...links,
                                        donutSubHeading: e.target.value,
                                      })
                                    }
                                  ></Form.Control>
                                </Form.Group>
                              </Col>
                            </>
                          )}
                        </Row>
                      </Card.Body>
                    </Card>

                    <hr className="centered-hr" />

                    <Card className="table-big-boy mb-5">
                      <Card.Header>
                        <div className="d-block d-md-flex align-items-center justify-content-between">
                          <Card.Title as="h4">Default Posts</Card.Title>
                        </div>
                      </Card.Header>
                      <Card.Body>
                        <Row>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Main Heading
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.defaultMainHeading}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    defaultMainHeading: e.target.value,
                                  })
                                }
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Sub Heading
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.defaultSubHeading}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    defaultSubHeading: e.target.value,
                                  })
                                }
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                    <hr className="centered-hr" />

                    <Card className="table-big-boy mb-5">
                      <Card.Header>
                        <div className="d-block d-md-flex align-items-center justify-content-between">
                          <Card.Title as="h4">Featured Posts</Card.Title>
                        </div>
                      </Card.Header>
                      <Card.Body>
                        <Row>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Main Heading
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.featuredMainHeading}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    featuredMainHeading: e.target.value,
                                  })
                                }
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Sub Heading
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.featuredSubHeading}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    featuredSubHeading: e.target.value,
                                  })
                                }
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                    <hr className="centered-hr" />
                    <Card.Footer>
                      <Row className="float-right">
                        {permissions && permissions.editSetting && (
                          <Col sm={12} className="d-flex">
                            <Button className="btn-filled mt-3" onClick={save}>
                              {" "}
                              Save{" "}
                            </Button>
                          </Col>
                        )}
                      </Row>
                    </Card.Footer>
                  </Card>
                </Form>
              </Col>
            </Row>
          </Container>
          {links.isDonut && (
            <SpendingChartForm
              donut={donut}
              setDonut={setDonut}
              permissions={permissions}
            />
          )}
          <SupportersForm
            oldSupporter={supporter}
            permissions={permissions}
          />
    </>
  );
};

export default SiteSettings;
